// extracted by mini-css-extract-plugin
export var label = "_hp-0";
export var treatmentCard = "_hp-1";